export const RECOMMENDATION_CONTEXT_FIELDS = [
  'stageIds',
  'wellboreTypeIds',
  'trajectoryTypeIds',
  'sectionTypeIds',
  'holeTypes',
  'stratUnitTypeIds',
  'reservoirIds',
  'runTypeIds',
  'operationIds',
] as const;

export const CONTEXT_COLUMN_FIELD = 'context';

export const RECOMMENDATION_MULTILINE_TEXT_FIELDS = [
  'recommendationMin',
  'recommendationMax',
  'recommendationDelta',
] as const;

export type TRecommendationMultilineTextField = (typeof RECOMMENDATION_MULTILINE_TEXT_FIELDS)[number];
